import { render, staticRenderFns } from "./BaseRimconfigTopBrand.vue?vue&type=template&id=46f22b32"
import script from "./BaseRimconfigTopBrand.vue?vue&type=script&lang=js"
export * from "./BaseRimconfigTopBrand.vue?vue&type=script&lang=js"
import style0 from "./BaseRimconfigTopBrand.vue?vue&type=style&index=0&id=46f22b32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports